import { useMemo } from "react";

import { ApiHttpService } from "./api-http-service";
import { ApplicantDocumentsApiService } from "./applicant-documents-api-service";
import { ApplicantsApiService } from "./applicants-api-service";

const useApiService = (apiRoutes) =>
    useMemo(() => {
        const apiHttpService = new ApiHttpService();

        return {
            applicants: new ApplicantsApiService(apiRoutes, apiHttpService),
            applicantDocuments: new ApplicantDocumentsApiService(
                apiRoutes,
                apiHttpService,
            ),
        };
    }, [apiRoutes]);

type ApiService = ReturnType<typeof useApiService>;

export { useApiService, type ApiService };
